import { render, staticRenderFns } from "./batchUpdateFaceToGrabbingDialog.vue?vue&type=template&id=675f0b82&scoped=true"
import script from "./batchUpdateFaceToGrabbingDialog.vue?vue&type=script&lang=js"
export * from "./batchUpdateFaceToGrabbingDialog.vue?vue&type=script&lang=js"
import style0 from "./batchUpdateFaceToGrabbingDialog.vue?vue&type=style&index=0&id=675f0b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f0b82",
  null
  
)

export default component.exports